export default "__VITE_ASSET__CNvS0vTf__"